// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2OZn5","addWidgetButton":"Header_addWidgetButton__36BWi","dashboardTabs":"Header_dashboardTabs__L6X4J","active":"Header_active__3b82b"};